export default [
  {
    path: '',
    component: () => import('@/layout'),
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/index'),
        meta: {
          icon: 'home',
          title: '首页',
          affix: true,
          auth: true,
          pageHeader: [],
          trackCode: 'menu-13',
          trackName: '首页',
        },
      },
    ],
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/account/login'),
    hidden: true,
  },
  {
    path: '/forgotPwd',
    name: 'ForgotPwd',
    component: () => import('@/views/account/forgotPwd'),
    hidden: true,
    meta: {
      title: '忘记密码',
    },
  },

  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/account/register'),
    hidden: true,
  },
  {
    path: '/404',
    name: 'NotFound',
    component: () => import('@/views/error-page/404'),
    hidden: true,
  },
  {
    path: '/403',
    name: 'NoAuth',
    component: () => import('@/views/error-page/403'),
    hidden: true,
  },
  {
    path: '/401',
    name: 'NoLogin',
    component: () => import('@/views/error-page/401'),
    hidden: true,
  },
  {
    path: '/redirect',
    component: () => import('@/layout'),
    hidden: true,
    children: [
      {
        path: '/redirect/:path*',
        component: () => import('@/views/redirect/index'),
      },
    ],
  },
];
